import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { FormControl } from '@angular/forms';
import 'rxjs/add/operator/debounceTime';

import {ApiService} from '../shared/api.service';
import {User} from '../shared/user.model';


@Component({
    selector: 'user-create',
    templateUrl: 'user-create.component.html'
})
export class UserCreateComponent {
    control = new FormControl();
    error = '';
    options = [];
    service;
    user;
    roles = [
        {
            value: 'administrator', viewValue: 'Administrator'
        },
        {
            value: 'editor', viewValue: 'Editor'
        },
        {
            value: 'writer', viewValue: 'Writer'
        },
        {
            value: 'dmc', viewValue: 'DMC'
        }
    ];

    constructor(private route: ActivatedRoute, private api: ApiService) {
        this.user = new User({});
        this.control.valueChanges.debounceTime(400).subscribe(
            value => {
                if( value ) {
                    this.getOptions(value); 
                } else {
                    this.options = [];
                }            
            }
        );
    }
    getOptions(text: string) {
        this.api.doAction('get', 'users', {
            context: 'edit',
            search: text,
            per_page: 100,
            role: 'administrator,editor,author,contributor',
            global: true
        }).subscribe(
            data => {
                this.options = data;
            }
        );
    }
    resetUser() {
        this.user = new User({});
    }
    setUser(event) {
        let user = event.option.value;
        switch(user.roles[0]) {
            case 'administrator':
                user.role = 'administrator';
                break;
            case 'editor':
                user.role = 'editor';
                break;
            case 'author':
                user.role = 'writer';
                break;
            case 'contributor':
                user.role = 'writer';
                break;
            default:
                break;
        }
        this.user = user;
    }
    addUser() {
        let user = this.user;
        if( !user.username || !user.email || !user.role ) {
            this.error = 'Please enter a username, email, and role.';
            return;
        }
        if( user.roles.length == 0 ) {
            user.roles = user.role == 'writer' ? ['author'] : [user.role];
        }
        user.password = 'Hello1126'; // Math.random().toString(36).slice(-8);
        this.api.doAction('post', 'users', this.user).subscribe(
            data => {
                console.log(data);
                this.resetUser();
            }
        );
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/users/user-create.component.ts